import React, { useState, useEffect } from "react";
import { Redirect, Link } from "react-router-dom";
import { useCookies } from "react-cookie";
import Navigation from "../partials/Navigation";
import { getExpiry } from '../common';
import {Helmet} from "react-helmet";
import { getUserData } from "../redux/actions/userdata";
import { useDispatch, useSelector } from "react-redux";
import HorizontalNav from "../partials/Dashboard/HorizontalNav";
import RecentArticles from "../partials/Dashboard/RecentArticles";
import HviChart from "../partials/Dashboard/HviChart";
import OviChart from "../partials/Dashboard/OviChart";
import { useTranslation } from "react-i18next";
import BatteryData from "../partials/MyBattery/BatteryData";
import Boards from "../partials/Boards";
import IntroCourse from "../partials/Dashboard/IntroCourse";
import Notifications from "../partials/Dashboard/Notifications";


const Home = () => {
  const [cookies, removeCookie] = useCookies([
    "sustainyou_user_jwt",
    "sustainyou_jwt_issued",
    "sustainyou_jwt_expire",
	"redirect_to"
  ]);
  
  	const dispatch = useDispatch();
	const userData = useSelector((state) => state.userdata.allUserData);
	const [isLoading, setIsLoading] = useState(false);

	const [translation] = useTranslation("translations");

  useEffect(() => {

	let expired = getExpiry("user_data_expire");

	const getAllUserData = async (token) => {
		setIsLoading(true);
		await dispatch(getUserData(token));
		setIsLoading(false)
	}

	if (cookies.sustainyou_user_jwt) {
		//const jwtDecoded = jwt_decode(cookies.sustainyou_user_jwt);
		
		if (expired) {
			getAllUserData(cookies.sustainyou_user_jwt);
		}
	}


  }, [dispatch, cookies]);

//   const refreshGraphs = async () => {

// 	if (cookies.sustainyou_user_jwt) {
// 		//const jwtDecoded = jwt_decode(cookies.sustainyou_user_jwt);

// 		setIsLoading(true);
// 		await dispatch(getUserData(cookies.sustainyou_user_jwt));
// 		setIsLoading(false);
// 	}
//   }

  if ( !userData && !isLoading ) {
	return (
		<Redirect to="/login/" />
	)
  }

  //console.log( cookies.redirect_to );

  if ( userData && cookies.redirect_to && !isLoading && !cookies.redirect_to.path ) {
	const redirectUrl = cookies.redirect_to;
	removeCookie("redirect_to", { path: "/" });
	return (
		<Redirect to={redirectUrl} />
	)
  }

  	return (
		<div className="main-wrapper">
			<Helmet>
				<title>{translation('dashboard')}</title>
				<meta name="description" content="" />
			</Helmet>

			<Navigation />

			<div className="page-content-wrap">
				
				<HorizontalNav title={translation('dashboard')} />
				
				<div className="pt-5 pt-lg-0 px-3 px-lg-4 page-content-inner" style={{maxWidth: "1440px"}}>

					<Notifications jwt={cookies.sustainyou_user_jwt} />

					<div className="row justify-content-center g-0">

						<div className="col-12 mt-3 mb-4">
							<div className="row">
								<div className="col-12 col-lg-8">
									<div className="dashboard-battery">
										<BatteryData />
									</div>

								</div>
								<div className="col-12 col-md-6 col-lg-4">
									<div className="bg-white px-3 pe-lg-4 ps-lg-3 py-3 mt-3">
										<RecentArticles />
									</div>

								</div>
							</div>
							
							<div className="row mt-3">

								<div className="col-12 col-lg-8">
									<div className="row">
										{userData?.all_capabilities && userData?.all_capabilities.includes('hwi') &&
											<div className="col-12 col-lg-6 mt-n3">
												<HviChart hvi={userData.hvi_data} loading={isLoading} organization={userData.organization} roles={userData?.roles} capabilities={userData?.all_capabilities} />
											</div>
											
										}
										<div className="col-12 col-lg-6">
											<Boards
												memberships={userData.membership_slugs}
												hvi={userData.hvi_data?.personal} 
												boardsLimit={userData?.boards_limit}
												capabilities={userData?.all_capabilities}
											/>
										</div>
									</div>
									<div className="row">
										{userData?.all_capabilities && userData?.all_capabilities.includes('owi') &&
											<div className="col-12 col-lg-6 mt-3">
												<OviChart ovi={userData.ovi_data} loading={isLoading} organization={userData.organization} roles={userData?.roles} capabilities={userData?.all_capabilities} />
											</div>
											
										}
									</div>
								</div>
								
								<div className="col-12 col-lg-4">
									
									<IntroCourse userOnboarded={userData.user_onboarded} loading={isLoading} />

									{/* {userData?.all_capabilities && userData?.all_capabilities.includes('owi') && (
										<div className="bg-white px-3 py-4 mb-3 rounded-3 shadow d-inline-block w-100">
											<div className="d-flex align-items-center flex-column flex-lg-row">
												<div className="flex-grow-1">
													<h5>Organisation Well Function Index</h5>
													<p className="opacity-half font-size-medium mb-0">Detta test ger dig och er svar på hur välfungerande du och ni tycker att organisationen är.</p>
												</div>
												<div className="ps-2 mt-3 mt-lg-0">
													<Link to="/ovi/" className="btn btn-secondary rounded-pill" style={{width: "200px"}}>
														<span className="pe-2">{translation('go_to_test')}</span>
														<i className="fa fa-angle-right" aria-hidden="true"></i>
													</Link>
												</div>
											</div>
										</div>
									)} */}
									
									{userData?.all_capabilities && userData?.all_capabilities.includes('community') && (

										<div className="bg-white px-3 py-3 mb-3 rounded-3 d-inline-block w-100">
											<div className="d-flex align-items-start flex-column">
												<div>
													<h5>{translation('community_text')}</h5>
													<p className="opacity-half font-size-medium mb-0 mt-3">{translation('commu_dash_desc')}</p>
												</div>
												<div className="ps-2 mt-3 mt-lg-0">
													<Link to="/settings/" className="btn btn-secondary rounded-pill mt-3 font-size-medium" >
														<span className="pe-2">{translation('create_account')}</span>
														<i className="fa fa-angle-right" aria-hidden="true"></i>
													</Link>
												</div>
											</div>
										</div>

									)}
								</div>
								
							</div>

						</div>

					</div>
				</div>
			</div>
		</div>
	);
};

export default Home;
